import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ciudadano',
  template: `
    <div>
    <router-outlet></router-outlet>
    </div>
    <!-- <app-footer-ciudadano></app-footer-ciudadano> -->
    `,
  styleUrls: []
})
export class CiudadanoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log("ciudadano.component");
  }

}
